import React from "react";
import img1 from "../../assets/images/home/safe-shield-img1.webp";
import img2 from "../../assets/images/home/support-svgrepo-img2.webp";
import img3 from "../../assets/images/home/appointment-svgrepo-img3.webp";
import img4 from "../../assets/images/home/job interview questions-svgrepo-img4.webp";
import "./index.css";

export const WhySection = () => {
  return (
    <div className="whyContainer">
      <div className="whyBannerContent">
        <h2>Why Listen Aura?</h2>
        <p>
          Because emotional support deserves more than just an app — it deserves
          trust, privacy, and real human connection.
        </p>
      </div>

      <div className="whyBannerGrid">
        <div className="cardContent">
          <img src={img1} alt="Anonymous & Safe" />
          <h3>Anonymous & Safe</h3>
          <p>
            Talk freely without revealing identity. Your privacy is always
            protected.
          </p>
        </div>

        <div className="cardContent">
          <img src={img2} alt="Human-First Support" />
          <h3>Human-First Support</h3>
          <p>Not bots. Real, trained listeners available when you need them.</p>
        </div>

        <div className="cardContent">
          <img src={img3} alt="Flexible Sessions" />
          <h3>Flexible Sessions</h3>
          <p>
            Start instantly or schedule at your convenience. Pay only for what
            you use.
          </p>
        </div>

        <div className="cardContent">
          <img src={img4} alt="In-Person Option" />
          <h3>In-Person Option</h3>
          <p>
            Now choose between secure online sessions and safe in-person
            meetings in your city.
          </p>
        </div>
      </div>

      <div className="whyButtonWrapper">
        <a href={`${process.env.REACT_APP_LISTENAURA_APP_URL}`} target="_blank"><button>Start Your Session</button></a> 
      </div>
    </div>
  );
};
